import { render, staticRenderFns } from "./SystemActivityWidget.vue?vue&type=template&id=d21b2f08&"
import script from "./SystemActivityWidget.vue?vue&type=script&lang=js&"
export * from "./SystemActivityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports